import { render, staticRenderFns } from "./DocumentLink.vue?vue&type=template&id=48fa492e&"
import script from "./DocumentLink.vue?vue&type=script&lang=js&"
export * from "./DocumentLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports